import React from 'react';
import { Text } from '../../../../../../../CommonComponents/OPL/Text/Text';

interface Props {
  label: string;
  value: string;
}

export const TableRowMobile = ({ label, value }: Props) => {
  return (
    <tr>
      <td>
        <Text textAlign="left">{label}</Text>
      </td>
      <td>
        <Text textAlign="right">{value}</Text>
      </td>
    </tr>
  );
};
